// src/services/leadSubmission.js

import { contactInfo } from '../mock/reviewsData';

const LEAD_EMAIL =
  contactInfo?.leadEmail ||
  contactInfo?.email ||
  'insureriskfree@gmail.com';

const WEB3FORMS_ACCESS_KEY ="a156aafa-4d12-483b-ab90-f83b09bc9d23";

async function sendForm(payload) {
  try {
    if (!WEB3FORMS_ACCESS_KEY) {
      throw new Error(
        'Web3Forms Access Key missing. Check .env file.'
      );
    }

    const response = await fetch(
      'https://api.web3forms.com/submit',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          access_key:WEB3FORMS_ACCESS_KEY,

          // Email configuration
          from_name: 'InsureRiskFree Website',
          replyto: LEAD_EMAIL,

          // Anti-spam
          botcheck: '',

          // Data
          ...payload,
        }),
      }
    );

    const result = await response.json();

    console.log(
      'Web3Forms Response:',
      result
    );

    if (response.ok && result.success) {
      return {
        ok: true,
        message:
          'Form submitted successfully',
      };
    }

    return {
      ok: false,
      error:
        result.message ||
        'Submission failed',
    };
  } catch (err) {
    console.error(
      'Form Submission Error:',
      err
    );

    return {
      ok: false,
      error:
        err.message ||
        'Something went wrong',
    };
  }
}

/**
 * Submit Lead Enquiry
 */
export async function submitLead({
  type,
  name,
  phone,
  city = '',
  message = '',
  extra = {},
}) {
  const payload = {
    subject: `New ${type} enquiry from ${
      name || 'Website Visitor'
    }`,

    Source:
      'InsureRiskFree Solutions Website',

    EnquiryType: type,
    Name: name,
    Phone: `+91 ${phone}`,
    City: city,
    Message: message,

    SubmittedAt:
      new Date().toLocaleString(
        'en-IN',
        {
          timeZone: 'Asia/Kolkata',
        }
      ),

    ...extra,
  };

  return sendForm(payload);
}

/**
 * Submit Appointment Booking
 */
export async function submitAppointment({
  category,
  reason,
  slot,
  phone,
}) {
  const payload = {
    subject: `📅 New Expert Call Booking - ${category} Insurance`,

    Source:
      'InsureRiskFree Solutions Website',

    BookingType:
      'Expert Call - SmartInsureGuru',

    InsuranceCategory: category,
    ReasonForConsultation: reason,
    PreferredTimeSlot: slot,
    PhoneNumber: `+91 ${phone}`,
    BookingStatus:
      'Pending Confirmation',

    BookedAt:
      new Date().toLocaleString(
        'en-IN',
        {
          timeZone: 'Asia/Kolkata',
        }
      ),
  };

  return sendForm(payload);
}